import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";

// Kicks of AI scheduling agent outreach
export function useStartStafferAgentConversation() {
  return useMutation({
    mutationFn: async (candidacyId: string) => {
      await guacHttpClient.post("staffer-agent-conversations", { candidacyId });
    },
  });
}
